<template>
  <div>
    <div class="header">
      <el-button type="primary" size="mini" class="elinput" @click="AddN2n" v-if="Permission.indexOf(175) != -1">
        {{ $t('lang.Button.Add') }}
      </el-button>
      <!-- <el-input size="mini" class="query" ">
        <el-button slot="append" icon="el-icon-search" ></el-button>
      </el-input> -->
      <el-select clearable size="mini" v-model="account" :filterable="true" :placeholder="$t('lang.n2n.inputGroupName')"
        :remote="true" :remote-method="queryInfoByAccount">
        <el-option v-for="(item, index) in AccountOptions" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <span style="margin-left: 10px;color: #999;">{{ $t('lang.n2n.queryTeam') }}</span>
      <el-button size="mini" type="success" style="margin-left: 10px;" @click="refreshServer">{{
        $t('lang.Button.refresh') }}</el-button>
    </div>
    <el-table :data="data" size="mini" height="650" v-loading="loading" row-key="serverId" @sort-change="sortChange"
      id="out-table" :header-cell-style="{ background: '#e4f1ff' }">
      <el-table-column type="selection" min-width="40"></el-table-column>
      <el-table-column :label="$t('lang.n2n.serverName')" sortable="custom">
        <template slot-scope="scope">
          <el-input size="mini" v-if="scope.$index == 0" clearable :placeholder="$t('lang.n2n.serverName')"
            v-model="seek.serverName"></el-input>
          <span class="spanov" :title="scope.row.serverName" v-if="scope.$index !== 0">
            {{ scope.row.serverName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.n2n.version')" sortable="custom">
        <template slot-scope="scope">
          <el-input size="mini" v-if="scope.$index == 0" :placeholder="$t('lang.n2n.version')" clearable
            v-model="seek.serverVersion">
          </el-input>
          <span class="spanov" :title="scope.row.serverVersion" v-if="scope.$index !== 0">
            {{ scope.row.serverVersion }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.n2n.serverAddress')" sortable="custom">
        <template slot-scope="scope">
          <el-input size="mini" v-if="scope.$index == 0" :placeholder="$t('lang.n2n.serverAddress')" clearable
            v-model="seek.serverHost">
          </el-input>
          <span class="spanov" :title="scope.row.serverHost" v-if="scope.$index !== 0">
            {{ scope.row.serverHost }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.n2n.port')" sortable="custom">
        <template slot-scope="scope">
          <el-input size="mini" v-if="scope.$index == 0" :placeholder="$t('lang.n2n.port')" clearable
            v-model="seek.serverPort">
          </el-input>
          <span class="spanov" :title="scope.row.serverPort" v-if="scope.$index !== 0">
            {{ scope.row.serverPort }}
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" :label="$t('lang.n2n.groupAutomaticDistribution')">
        <template slot-scope="scope">
          <div v-if="scope.$index !== 0">
            <el-tag v-if="!scope.row.serverSwitch">{{ $t('lang.ConfigSetting.Disable') }}</el-tag>
            <el-tag v-else>{{ $t('lang.ConfigSetting.Enable') }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.n2n.totalGroups')" sortable="custom">
        <template slot-scope="scope">
          <el-input size="mini" v-if="scope.$index == 0" :placeholder="$t('lang.n2n.totalGroups')" clearable
            v-model="seek.groupNum">
          </el-input>
          <span class="spanov" :title="scope.row.groupNum" v-if="scope.$index !== 0">
            {{ scope.row.groupNum }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.n2n.totaldevices')" sortable="custom">
        <template slot-scope="scope">
          <el-input size="mini" v-if="scope.$index == 0" :placeholder="$t('lang.n2n.totaldevices')" clearable
            v-model="seek.deviceNum">
          </el-input>
          <span class="spanov" :title="scope.row.deviceNum" v-if="scope.$index !== 0">
            {{ scope.row.deviceNum }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.n2n.createTime')" sortable="custom" width="200">
        <template slot-scope="scope">
          <el-input size="mini" v-if="scope.$index == 0" :placeholder="$t('lang.n2n.createTime')" width="240" clearable
            v-model="seek.serverCreate"></el-input>
          <span class="spanov" :title="scope.row.serverCreate" v-if="scope.$index !== 0">
            {{ scope.row.serverCreate }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.TableComponent.operating')" align="center" width="200">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" @click="updateN2nServer(scope.row)" circle
            v-if="scope.$index !== 0 && Permission.indexOf(191) != -1">
          </el-button>
          <el-tooltip class="item" effect="dark" :content="$t('lang.n2n.groupManagement')" placement="top">
            <el-button type="success" icon="icon-huiyuanfenzuguanli"
              v-if="scope.$index !== 0 && Permission.indexOf(193) != -1" @click="queryKeywordGroupInfo(scope.row)"
              circle>
            </el-button>
          </el-tooltip>
          <el-button type="danger" icon="el-icon-delete" circle
            v-if="scope.$index != 0 && Permission.indexOf(192) != -1" @click="DeleteN2n(scope.row)">
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <pagination :total="total" :offset="offset" :limit="limit" @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges">
    </pagination>
    <!-- 添加n2n修改n2n修改分组端口号组件 -->
    <n2ndialog :title="DialogTitle" @AddAndSetN2nServer="AddAndSetN2nServer" :Identification="Identification" :n2n="n2n"
      ref="dialog">
    </n2ndialog>
    <!-- n2n下的分组表格 -->
    <group-table :serverId="serverId" ref="GroupTable" :N2nInformation="N2nInformation" @Getn2nList="queryKeyword">
    </group-table>
  </div>
</template>
<script>
import {
  addN2nServer,
  delN2nServer,
  updateN2nServer,
  queryKeyword,
  queryKeywordGroupInfo,
  queryKeywordByRemoteAccount,
  refreshRemoteServer
} from "@/api/remoteservice"
import { PublicComponent } from "../../../mixins/common"
import n2ndialog from "../components/n2ndialog"
import GroupTable from '../components/GroupTable'
import pagination from "@/components/pagination"
import { getPermission } from "../../../cookie/cookie";
export default {
  mixins: [PublicComponent],
  name: 'Remoteservice',
  data() {
    return {
      //权限数组
      Permission: [],
      data: [],
      DialogTitle: "",
      n2n: {},
      Identification: null,
      //修改获取serverId
      serverId: null,
      //查询
      seek: {
        deviceNum: "",
        groupNum: "",
        serverName: "",
        serverVersion: "",
        serverPort: "",
        serverCreate: "",
        serverHost: "",
      },
      //排序
      sort: {
        deviceNum: null,
        groupNum: null,
        serverName: null,
        serverVersion: null,
        serverPort: null,
        serverCreate: null
      },
      outerVisible: false,
      innerVisible: false,
      //n2n分组列表
      GroupList: [],
      //原服务信息
      N2nInformation: {},
      AccountOptions: [],
      account: "",
      loading: false
    };
  },
  activated() {
    //获取n2n数据
    this.queryKeyword();
    //获取权限列表
    this.Permission = getPermission();
  },
  components: {
    n2ndialog,
    pagination,
    GroupTable
  },
  methods: {
    //添加n2n数据
    AddN2n() {
      this.DialogTitle = this.$t('lang.Button.Add');
      this.Identification = 1;
      this.$refs.dialog.dialogVisible = true;
      //传给子组件
      this.n2n = {
        serverName: "",
        serverVersion: "",
        serverPort: null,
        serverSwitch: true
      };
    },
    //修改n2n数据
    updateN2nServer(item) {
      this.DialogTitle = this.$t('lang.Button.edit');
      this.Identification = 2;
      this.$refs.dialog.dialogVisible = true;
      //存储serverId
      this.n2n = {
        serverId: item.serverId,
        serverName: item.serverName,
        serverVersion: item.serverVersion,
        serverPort: item.serverPort,
        serverHost: item.serverHost,
        serverSwitch: item.serverSwitch == 1 ? true : false
      };
    },
    //获取添加的数据
    AddAndSetN2nServer(props, Identification) {
      switch (Identification) {
        //新增
        case 1: {
          addN2nServer(props).then(res => {
            this.queryKeyword();
            if (res.data.code === 0) {
              this.$message({
                message: this.$t('lang.Button.successAdd'),
                type: "success"
              });
            }
            else if (res.data.code === 39) {
              this.$message({
                message: this.$t('lang.n2n.portRepeat'),
                type: "warning"
              });
            }
            else {
              this.$message({
                message: this.$t('lang.Button.failAdd'),
                type: "warning"
              });
            }
          });
          break;
        }
        //修改
        case 2: {
          const serverId = this.serverId;
          updateN2nServer(props).then(res => {
            this.queryKeyword();
            if (res.data.code === 0) {
              this.$message({
                message: this.$t('lang.Button.successEdit'),
                type: "success"
              });
            } else {
              this.$message({
                message: this.$t('lang.Button.failEdit'),
                type: "warning"
              });
            }
          });
          break;
        }
      }
    },
    //删除n2n
    DeleteN2n(item) {
      if (item.deviceNum) {
        this.$message({
          message: this.$t('lang.n2n.PresenceDevice'),
          type: "warning"
        })
        return
      } else if (item.groupNum) {
        this.$message({
          message: this.$t('lang.n2n.PresenceGroup'),
          type: "warning"
        })
        return
      }
      this.$confirm(this.$t('lang.n2n.deleteN2n'), this.$t('lang.Button.tips'), {
        confirmButtonText: this.$t('lang.Button.submit'),
        cancelButtonText: this.$t('lang.Button.cancel'),
        type: 'warning',
        center: true
      }).then(() => {
        delN2nServer(item.serverId).then(res => {
          this.queryKeyword();
          if (res.data.code === 0) {
            this.$message({
              message: this.$t('lang.Button.successDelete'),
              type: "success"
            });
          } else {
            this.$message({
              message: this.$t('lang.Button.failDelete'),
              type: "warning"
            });
          }
        });
      })
    },
    //排序
    sortChange({ column, prop, order }) {
      this.sort = {
        deviceNum: null,
        groupNum: null,
        serverName: null,
        serverVersion: null,
        serverPort: null,
        serverCreate: null,
        serverAddress: null
      };
      // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
      let label = null;
      if (column != null) {
        label = column.label;
      } else {
        label = null;
      }
      let sortlist = null;
      if (column != null) {
        if (column.order == "ascending") {
          sortlist = 0;
        } else if (column.order == "descending") {
          sortlist = 1;
        } else {
          sortlist = null;
        }
      }
      switch (label) {
        case this.$t('lang.n2n.serverName'): {
          this.sort.serverName = sortlist;
          console.log(this.sort)
          break;
        }
        case this.$t('lang.n2n.version'): {
          this.sort.serverVersion = sortlist;
          break;
        }
        case this.$t('lang.n2n.port'): {
          this.sort.serverPort = sortlist;
          break;
        }
        case this.$t('lang.n2n.totalGroups'): {
          this.sort.groupNum = sortlist;
          break;
        }
        case this.$t('lang.n2n.totaldevices'): {
          this.sort.deviceNum = sortlist;
          break;
        }
        case this.$t('lang.n2n.createTime'): {
          this.sort.serverCreate = sortlist;
          break;
        }
        case this.$t('lang.n2n.serverAddress'): {
          this.sort.serverAddress = sortlist;
          break;
        }
      }
    },
    //搜索排序分页
    queryKeyword() {
      queryKeyword(
        [
          this.seek.serverName,
          this.seek.serverVersion,
          this.seek.serverPort,
          this.seek.groupNum,
          this.seek.deviceNum,
          this.seek.serverCreate,
          this.seek.serverHost,
        ],
        this.sort,
        this.offset,
        this.limit
      ).then(res => {
        res.data.data.list.forEach(item => {
          item.serverSwitch = item.serverSwitch == 1 ? true : false;
        });
        this.data = res.data.data.list;
        this.total = res.data.data.total;
        this.offset = res.data.data.offset;
        this.limit = res.data.data.limit;
        this.data.unshift({});
        this.account = ""
        this.AccountOptions = []
      });
    },
    //n2n下的分组修改
    queryKeywordGroupInfo(item) {
      //获取当前n2nid
      this.serverId = item.serverId
      //获取当前n2n信息
      this.N2nInformation = item
      //打开弹框
      this.$refs.GroupTable.outerVisible = true
    },
    queryInfoByAccount(val) {
      queryKeywordByRemoteAccount(val).then(res => {
        if (res.data.data.list) {
          let data = res.data.data.list.map(v => {
            return {
              label: v.serverName,
              value: v.serverName
            }
          })
          this.AccountOptions = data
        }
      })
    },
    refreshServer() {
      this.loading = true
      refreshRemoteServer().then(res => {
        this.$message({
          message: this.$t('lang.Button.successOperation'),
          type: "success"
        });
      }).catch(err => {
        console.log(err);
        this.$message({
          message: this.$t('lang.Button.failOperation'),
          type: "error"
        });
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    account(val) {
      if (val) {
        this.seek.serverName = val
      }
    }
  }
};
</script>
<style scoped>
.elinput {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}

.spanov {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.25rem;
  height: 41px;
  display: block;
  line-height: 41px;
}

.tetxp {
  display: inline-block;
  width: 2rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}

.admininput {
  display: inline-block;
  width: 4rem;
  margin: 0.2rem;
}

.header {
  display: flex;
  align-items: center;
}

.header>.query {
  width: 4rem;
}
</style>
